import React from "react";
import * as Sentry from "@sentry/react";
import { ErrorFallback } from "components/ErrorBoundaries/ErrorFallback";

export const SentryErrorBoundary = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      {children}
    </Sentry.ErrorBoundary>
  );
};
